module.exports = __webpack_public_path__ + "img/eg.svg";